export default {
    carregando: false,
    items: [],
    paginacao: {
        per_page: 100,
        current_page: 1,
        last_page: 1,
        total: 0,
        from: 1,
        to: 0
    },
    selecionado: {
        from: '',
        to: '',
        body: '',
        enfileirado: false,
        tentativas: 0,
        log_falha: null,
        sended_at: null
    }
}
